import { jsx } from "react/jsx-runtime";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { validateTidalLicense } from "../../base/index.js";
function HelpCenter(props) {
  return /* @__PURE__ */ jsx(
    HelpCenterIcon,
    {
      "data-testid": "HelpCenter",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "HelpCenter",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
HelpCenter.tidalIconMeta = {
  categories: "cancel,informative",
  name: "HelpCenter"
};
validateTidalLicense();
export {
  HelpCenter
};
//# sourceMappingURL=HelpCenter.js.map
